/* eslint-disable react/jsx-curly-newline */
import * as React from 'react';

import MultiraceTable from '@/components/layouts/Result/MultiraceTable';
import { MultiraceProgram } from '@/lib/apollo/types/gen/graphql';
import { orderByMultiraceType } from '@/lib/race/multirace';
import { RaceType } from '@/modelTypes';

import ResultUI, { ResultTemplateProps } from '..';
import { ResultsNotExistText } from '../style';
import { CancelText, Card, CardHeader, CardList, ProgramName } from './style';

interface MultiraceResultTemplateProps extends ResultTemplateProps {
  multiracePrograms: MultiraceProgram[];
}

const MultiraceResultTemplate: React.FC<MultiraceResultTemplateProps> = ({
  multiracePrograms,
  raceProgram,
}) => {
  return (
    <ResultUI
      raceProgram={raceProgram}
      raceType={RaceType.Multirace}
      width="840px"
    >
      {multiracePrograms.length ? (
        <CardList>
          {orderByMultiraceType(multiracePrograms).map((mp, i) => (
            <Card key={`${mp.id}-${i}`}>
              <CardHeader>
                <ProgramName>{mp.programName}</ProgramName>
                {mp.isCanceled && <CancelText>中止</CancelText>}
              </CardHeader>
              <MultiraceTable multiraceProgram={mp} displayChanceCount />
            </Card>
          ))}
        </CardList>
      ) : (
        <ResultsNotExistText>レース結果はありません</ResultsNotExistText>
      )}
    </ResultUI>
  );
};

export default MultiraceResultTemplate;
